const routes = [
  {
    path: '/',
    // 默认落地页统一为创意制作智能体广场（原为智能体集群输入页）
    redirect: '/offerAgentPlaza',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        redirect: '/offerAgentPlaza'
      },
      {
        path: '/brandStandard/:tabType?',
        name: 'BrandStandard',
        component: () => import('@/views/brandStandard/index.vue'),
        meta: {
          title: '',
          menuPath: 'BrandStandard',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/brandVoice/:id?',
        name: 'BrandVoice',
        component: () => import('@/views/brandVoice/index.vue'),
        meta: {
          title: '品牌之声',
          menuPath: 'BrandVoice',
          permission: {
            old: [],
            new: []
          },
          shrink: true,
          sliderMenu: true
        }
      },
      {
        path: '/agentCluster',
        name: 'AgentCluster',
        // 侧栏已下线普通版「策略规划智能体」，入口统一落到创意制作智能体广场
        redirect: '/offerAgentPlaza'
      },
      {
        path: '/agentCluster/input/:templateCode/:subCode/:clusterCode',
        name: 'AgentClusterInput',
        component: () => import('@/views/agentCluster/input.vue'),
        meta: {
          title: '智能体集群输入',
          menuPath: 'AgentCluster',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/agentCluster/chat/:templateCode/:subCode/:clusterCode/:id',
        name: 'AgentClusterChat',
        component: () => import('@/views/agentCluster/chat.vue'),
        meta: {
          title: '智能体集群聊天',
          menuPath: 'AgentCluster',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/myCampaign',
        name: 'MyCampaign',
        component: () => import('@/views/myPage/myCampaign.vue'),
        meta: {
          title: '我管理的Campaign',
          menuPath: 'myCampaign',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/myOffer',
        name: 'MyOffer',
        component: () => import('@/views/myPage/myOffer.vue'),
        meta: {
          title: '我制作的Offer',
          menuPath: 'MyOffer',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/myResource/:tabType?',
        name: 'MyResource',
        component: () => import('@/views/brandStandard/index.vue'),
        meta: {
          title: '我的素材资产',
          menuPath: 'MyResource',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/offerAgentPlaza',
        name: 'OfferAgentPlaza',
        component: () => import('@/views/offerAgentPlaza/index.vue'),
        meta: {
          title: 'Offer智能体广场',
          menuPath: 'WritingAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/offerAgentChat/:agentType?/:code?/:templateId?/:id?/:subCode?',
        name: 'OfferAgentChat',
        component: () => import('@/views/offerAgentPlaza/chat.vue'),
        meta: {
          title: 'Offer智能体会话',
          menuPath: 'WritingAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/lobsterPlaza',
        name: 'LobsterPlaza',
        component: () => import('@/views/lobsterPlaza/index.vue'),
        meta: {
          title: '岗位助理智能体',
          menuPath: 'LobsterPlaza',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/strategyPlanning',
        name: 'StrategyPlanning',
        component: () => import('@/views/strategyPlanning/index.vue'),
        meta: {
          title: '策略规划智能体',
          menuPath: 'StrategyPlanning',
          permission: {
            old: [],
            new: []
          },
          /* 灰度演示入口：未命中名单时直接输 URL 也进不来（守卫见 src/router/index.js）。
             这只保证前端「菜单藏了」与「路由挡了」口径一致，不是访问控制 */
          demoOnly: true,
          // iframe 整页铺满，进入时默认收起左侧主菜单，用户仍可手动展开
          collapseMainMenu: true
        }
      },
      {
        path: '/cmoDashboard',
        name: 'CmoDashboard',
        component: () => import('@/views/cmoDashboard/index.vue'),
        meta: {
          title: '营销管理指挥室',
          menuPath: 'CmoDashboard',
          permission: {
            old: [],
            new: []
          },
          // 同 /strategyPlanning，灰度演示入口
          demoOnly: true
        }
      },
      {
        path: '/writingAgent/:code?/:templateId?/:id?',
        name: 'aiAgent',
        component: () => import('@/views/aiAgent/index.vue'),
        meta: {
          title: '写作智能体 ',
          menuPath: 'WritingAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/designAgent/:code?/:templateId?/:id?',
        name: 'DesignAgent',
        component: () => import('@/views/designAgent/index.vue'),
        meta: {
          title: '设计智能体 ',
          menuPath: 'DesignAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/videoAgent/:code?/:subCode?/:templateId?/:id?',
        name: 'VideoAgent',
        component: () => import('@/views/videoAgent/index.vue'),
        meta: {
          title: '视频智能体',
          menuPath: 'VideoAgent',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('@/views/knowledgeBase/index.vue'),
        meta: {
          title: '知识库',
          menuPath: 'Knowledge',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/copywritingModel',
        name: 'CopywritingModel',
        component: () => import('@/views/enterpriseModel/copywritingModel/index.vue'),
        meta: {
          title: '文案模型',
          menuPath: 'CopywritingModel',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/designPattern',
        name: 'DesignPattern',
        component: () => import('@/views/enterpriseModel/designPattern/index.vue'),
        meta: {
          title: '设计模型',
          menuPath: 'DesignPattern',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/enterpriseModel/videoModel',
        name: 'VideoModel',
        component: () => import('@/views/enterpriseModel/videoModel/index.vue'),
        meta: {
          title: '视频模型',
          menuPath: 'VideoModel',
          permission: {
            old: [],
            new: []
          }
        }
      },
      {
        path: '/user/userSetting',
        name: 'UserSetting',
        component: () => import('@/views/user/user.vue'),
        meta: {
          title: '个人中心',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/userSafe',
        name: 'UserSafe',
        component: () => import('@/views/user/user.vue'),
        meta: {
          title: '个人中心',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },

      {
        path: '/user/combo',
        name: 'combo',
        component: () => import('@/views/user/combo.vue'),
        meta: {
          title: '我的套餐',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/consumption',
        name: 'consumption',
        component: () => import('@/views/user/consumption.vue'),
        meta: {
          title: '消耗日志',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/purchasePlan',
        name: 'purchasePlan',
        component: () => import('@/views/user/purchasePlan.vue'),
        meta: {
          title: '套餐购买',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/checkIn',
        name: 'checkIn',
        component: () => import('@/views/user/checkIn.vue'),
        meta: {
          title: '每日签到',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/user/invitation',
        name: 'invitation',
        component: () => import('@/views/user/invitation.vue'),
        meta: {
          title: '邀请好友',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamPackage',
        name: 'teamPackage',
        component: () => import('@/views/team/teamPackage.vue'),
        meta: {
          title: '团队/企业套餐',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamConsumption',
        name: 'teamConsumption',
        component: () => import('@/views/team/teamConsumption.vue'),
        meta: {
          title: '团队/企业消耗日志',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/teamBuy',
        name: 'teamBuy',
        component: () => import('@/views/team/teamBuy.vue'),
        meta: {
          title: '团队/企业套餐购买',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/memberManagement',
        name: 'memberManagement',
        component: () => import('@/views/team/memberManagement.vue'),
        meta: {
          title: '成员管理',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      },
      {
        path: '/team/memberSetting',
        name: 'memberSetting',
        component: () => import('@/views/team/memberSetting.vue'),
        meta: {
          title: '团队设置',
          permission: {
            old: [],
            new: []
          },
          sliderMenu: true,
          menuSlider: true
        }
      }
    ]
  },
  {
    path: '/editorPage/:code?/:externalRecordId?/:externalTitleId?/:externalToolCallId?/:externalResultId?',
    name: 'editorPage',
    component: () => import('@/views/artboardCanvas/index.vue'),
    meta: {
      title: '编辑器',
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/modelTraining/:templateId?/:type?',
    name: 'modelTraining',
    component: () => import('@/views/designAgent/modelTraining.vue'),
    meta: {
      title: '训练模型',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/videoModelTraining/:templateId?/:type?',
    name: 'videoModelTraining',
    component: () => import('@/views/videoAgent/videoModelTraining.vue'),
    meta: {
      title: '视频智能体训练模型',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 视频智能体 · 分镜参考图编辑器：Story board 参考图上的「编辑」按钮新开标签页进来。
       与 /editorPage（设计智能体的海报编辑器）分开的两条路由，别混用：那边要跨应用
       token、走海报的详情与保存接口、保存时可选「覆盖 / 新版本」；本页在站内登录态下
       直接打开，详情与保存走视频智能体自己的接口，且只允许覆盖当前参考图。
       params 定位「哪条镜头的哪条素材」：
         scriptId    版本根行 id。按它精确查详情——编辑即出新版本，按 isUsed=1 查回来的
                     未必是点「编辑」时看到的那一版，镜头 id 也就对不上了；
         shotId      镜头行 id（scriptShortId）；
         materialUid 素材的稳定标识，缺省时按旧口径取镜头顶层的 image_urls。 */
    path: '/videoShotImageEditor/:scriptId/:shotId/:materialUid?',
    name: 'videoShotImageEditor',
    component: () => import('@/views/videoAgent/shotImageEditor.vue'),
    meta: {
      title: '参考图编辑',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 视频画布物料海报编辑器：分镜视频画布里镜头详情的静帧图「编辑」新开标签页进入。
       与上面同一个页面组件（shotImageEditor），按路由名切到「视频画布物料」接口
       （service/api/videoCanvasEditor.js）：canvasId 画布行 id，materialUid 物料 canvas.materials[].uid。
       保存原地覆盖物料图片，不生成版本。 */
    path: '/videoCanvasImageEditor/:canvasId/:materialUid',
    name: 'videoCanvasImageEditor',
    component: () => import('@/views/videoAgent/shotImageEditor.vue'),
    meta: {
      title: '静帧图编辑',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* Story board 独立页面：脚本生成的分镜列表右上角新开标签页进入。
       顶层路由（不放进 index 的 children），所以不带左侧菜单与站内头部。
       入参是与脚本详情同一组的三个 id，都必传，所以写成 path 上的必填 params
       （不加 ?）——缺任何一个都匹配不到本路由，页面侧按 route.params 读。
       末尾两段 templateCode / subCode 可选（带 ?），给 getChatContent 查会话是否有生成中的任务用
       （本页新开标签页，拿不到对话页内存里的 chatDetail），缺了也能打开 */
    path: '/storyboard/:titleId/:toolCallId/:videoRecordId/:templateCode?/:subCode?',
    name: 'videoStoryboard',
    component: () => import('@/views/videoAgent/storyboard.vue'),
    meta: {
      title: 'Story board',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* Story board 分享页：与上面同一个组件、同一组 params，只多一个 meta.share。
       页面靠它切成只读——顶栏只留「导出 PDF」，分镜只能看与预览参考图，
       不给编辑、拖拽、增删入口。两条路由共用组件，版式与取数逻辑不会走岔。
       入口：Story board 顶栏的「分享」（复制本路由的链接）。 */
    path: '/storyboard-share/:titleId/:toolCallId/:videoRecordId',
    name: 'videoStoryboardShare',
    component: () => import('@/views/videoAgent/storyboard.vue'),
    meta: {
      title: 'Story board 分享',
      share: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 视频智能体 · 创意脚本：黑色介绍栏 + Markdown 正文，可切换版本、保存为新版本、分享、评论，
       「保存并生成镜头脚本」进入下一步。入参与 Story board 同一组三件套，都必传。
       入口：会话里 idea_script_generation_tool 的卡片（chat/blockTag），新窗口打开。
       末尾两段 templateCode / subCode 可选（带 ?），「保存并生成镜头脚本」继续对话前查会话是否生成中用
       （本页新开标签页，拿不到对话页内存里的 chatDetail），缺了也能打开 */
    path: '/idea-script/:titleId/:toolCallId/:videoRecordId/:templateCode?/:subCode?',
    name: 'videoIdeaScript',
    component: () => import('@/views/videoAgent/ideaScript.vue'),
    meta: {
      title: '创意脚本',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 创意脚本分享页：同一个组件、同一组 params，多一个 meta.share 切成只读（只能看、评论） */
    path: '/idea-script-share/:titleId/:toolCallId/:videoRecordId',
    name: 'videoIdeaScriptShare',
    component: () => import('@/views/videoAgent/ideaScript.vue'),
    meta: {
      title: '创意脚本分享',
      share: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 视频智能体 · 分镜视频画布：幕与镜头摊在一块可自由摆放的 DOM 画布上，逐镜生成分镜视频。
       顶层路由（不放进 index 的 children），所以不带左侧菜单与站内头部，顶栏只有返回与标题。
       入参与 Story board 同一组三件套（titleId / toolCallId / videoRecordId），都必传。
       页面按 route.params 调 bv-video-canvas/group-list 取数（见 service/api/videoAgent.js）。
       末尾两段 templateCode / subCode 是可选的（带 ?），给 getChatContent 查会话记录判断是否只读用；
       缺了也能打开，页面会退回用会话详情里的值。 */
    path: '/shotVideoCanvas/:titleId/:toolCallId/:videoRecordId/:templateCode?/:subCode?',
    name: 'shotVideoCanvas',
    component: () => import('@/views/videoAgent/shotVideoCanvas.vue'),
    meta: {
      title: '分镜视频画布',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    /* 分镜视频画布分享页：与上面同一个组件、同一组三件套 params，只多一个 meta.share。
       页面靠它切成只读——不能生成视频、改镜头、切版本，顶栏只留「评论」；可以平移缩放、播放视频、
       评论分镜。免登录打开。入口：画布顶栏的「分享」（复制本路由的链接）。 */
    path: '/shotVideoCanvas-share/:titleId/:toolCallId/:videoRecordId',
    name: 'shotVideoCanvasShare',
    component: () => import('@/views/videoAgent/shotVideoCanvas.vue'),
    meta: {
      title: '分镜视频画布 分享',
      share: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/aiAgentStyle/:id',
    name: 'aiAgentStyle',
    component: () => import('@/views/aiAgent/aiAgentStyle.vue'),
    meta: {
      title: '训练风格',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/aiAgentStyle/:id/:itemId',
    name: 'aiAgentStyleEdit',
    component: () => import('@/views/aiAgent/aiAgentStyle.vue'),
    meta: {
      title: '训练风格',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/invitePage',
    name: 'InvitePage',
    component: () => import('@/views/team/invitePage.vue'),
    meta: {
      title: '团队/企业管理邀请页面',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
    meta: {
      title: '登录',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agreement/userAgreement',
    name: 'userAgreement',
    component: () => import('@/views/agreement/userAgreement.vue'),
    meta: {
      title: '使用协议',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agreement',
    name: 'privacyAgreement',
    component: () => import('@/views/agreement/privacyAgreement.vue'),
    meta: {
      title: '隐私保护协议',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/pdfDetail/:contentId',
    name: 'pdfDetail',
    component: () => import('@/views/aiBrain/pdfDetail.vue'),
    meta: {
      title: 'pdf详情',
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/knowledgeShare/:code',
    name: 'knowledgeShareFolder',
    component: () => import('@/views/knowledgeBase/knowledgeShare.vue'),
    meta: {
      title: '文件分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      },
      fixurl: (route) => {
        return process.env.VUE_APP_knowledge_H5_URL + route.params.code
      }
    }
  },
  {
    path: '/aiAgentShare/:id',
    name: 'aiAgentShare',
    component: () => import('@/views/aiAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.id
      // }
    }
  },
  {
    path: '/designAgentShare/:id/:code?/:subCode?',
    name: 'designAgentShare',
    component: () => import('@/views/designAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/videoAgentShare/:id/:code?',
    name: 'videoAgentShare',
    component: () => import('@/views/videoAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/agentClusterChatShare/:templateCode/:subCode/:clusterCode/:id',
    name: 'AgentClusterChatShare',
    component: () => import('@/views/agentCluster/share.vue'),
    meta: {
      title: '智能体集群聊天分享',
      menuPath: 'AgentCluster',
      permission: {
        old: [],
        new: []
      },
      shrink: true,
      sliderMenu: true
    }
  },
  {
    path: '/designAgentMaterialShare/:id',
    name: 'designAgentMaterialShare',
    component: () => import('@/views/designAgent/share.vue'),
    meta: {
      title: 'ai智能体分享',
      hideFloatBtn: true,
      noLogin: true,
      permission: {
        old: [],
        new: []
      }
      // fixurl: (route) => {
      //   return process.env.VUE_APP_AIVIDEO_H5_URL + route.params.id
      // }
    }
  },
  {
    path: '/pageStatus/:code',
    name: 'pageStatus',
    component: () => import('@/views/status/index.vue'),
    meta: {
      title: '状态页面',
      hideFloatBtn: true,
      permission: {
        old: [],
        new: []
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/pageStatus/notFound'
  }
]

export default routes
